import { Statistic } from '../types/statistics'

export const mergeStatisticByName =
  (language: string) =>
  (prev: Statistic[], curr: Statistic): Statistic[] => {
    const el = prev.find((stat) => stat.tagName[language] === curr.tagName[language] && stat.tagType === curr.tagType)
    if (!el) {
      return [...prev, { ...curr }]
    }
    return prev
  }
